<template>
<div>
    <div>
        <!-- Filtros de busqueda con boton -->
        <div class="ibox sombra-light">
            <div class="ibox-title">
                <h5>
                    <i class="fal fa-chart-bar"></i> Configuracion de
                    discord
                </h5>
                <div class="ibox-tools">
                    <button class="btn-primary" @click="agregar" >{{ !nuevo && !editando ? "Agregar"  : "Volver"}}</button>
                </div>
            </div>
            <div class="ibox-content" v-if="!nuevo && !editando">
                <data-table :id="dt.id" :datos="dt.datos" :columnas="dt.columnas" :responsive="true" :font-size="12">
                    <template v-slot:activo="item">
                        <switchh class="ml-4 mt-2" :isEnabled="item.data.activo" @toggle="activar(item.data)" />
                    </template>
                    <template v-slot:opciones="item">
                        <button class="btn btn-gray" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="editar(item)">
                            Editar
                        </button>
                        <!-- <div class="dropdown float-right">
                            <button class="btn btn-gray btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Opciones
                            </button>
                            <ul class="dropdown-menu dropdown-menu-right">
                                <li>
                                    
                                    <a href="javascript:void(0)" @click="eliminar(item.data.id)">
                                        <i class="fal fa-trash-alt"></i> Eliminar
                                    </a>
                                </li>
                            </ul>
                        </div> -->
                    </template>
                </data-table>
            </div>
            <form @submit.prevent="save" v-if="nuevo || editando">
                <div class="ibox-content">
                    <b-overlay rounded="sm">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div style="display: flex;">
                                        <h2>Discord</h2>
                                    </div>
                                  
                                   
                                    <br />
                                </div>
                                <div class="col-6" v-if="discord_local && discord_local.activo">
                                    <div class="form-group">
                                        <label>Nombre</label>
                                    <input type="text" class="form-control " v-model="discord_local.nombre">
                                    </div>
                                </div>
                                <div class="col-12" v-if="discord_local && discord_local.activo">
                                    <div class="form-group">
                                        <label>URL</label>
                                        <input type="text" class="form-control " v-model="discord_local.url">
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div v-if="discord_local && discord_local.activo">
                                <div class="row">
                                    <div class="col">
                                        <div style="display: flex;">
                                            <h2>Menciones</h2>
                                        </div>

                                        <hr>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group text-center">
                                            <multiselect v-model="discord_local.etiquetas" :options="menciones" :multiple="true" track-by="value" label="text" :close-on-select="false" :hide-selected="true" selectLabel="Presione para seleccionar" open-direction="bottom" placeholder="Todos" />
                                        </div>
                                    </div>
                                </div>

                                <!--  -->

                                <div class="row">
                                    <div class="col">
                                        <h2>Proveedores y Parametros</h2>
                                        <hr>
                                    </div>
                                </div>
                                <div class="row mb-2" v-if="discord_local.parametros_activos.length > 0">
                                    <div class="col-12">
                                        <label>Activos</label>
                                    </div>
                                    <div class="col-3 text-center mb-2" v-for="(item, index) in discord_local.parametros_activos" :key="index">
                                        <div>
                                            <div style="display:flex;border: 1px solid #eee; border-radius: 5px;">
                                                <div @click="eliminar(item,index)" style="    text-align: end; margin-right: 13px; margin-left: 10px; cursor: pointer;">
                                                    <i class="fa fa-times" aria-hidden="true" style="color:red"></i>
                                                </div>
                                                <div>
                                                    <div>
                                                        Proveedor: {{item.proveedor}}
                                                    </div>
                                                    <div>
                                                        Metodo: {{item.metodo}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <label>Agregar</label>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group text-center">
                                            <label>Proveedor</label>
                                            <multiselect v-model="proveedor" :options="proveedores_local" track-by="value" label="text" :close-on-select="true" :hide-selected="true" selectLabel="Presione para seleccionar" open-direction="bottom" placeholder="Todos" />
                                        </div>
                                    </div>
                                    <div class="col-6" v-if="proveedor">
                                        <div class="form-group text-center">
                                            <label>Proveedor</label>
                                            <multiselect v-model="parametro" :options="paramentros_proveedor" track-by="value" label="text" :close-on-select="true" :hide-selected="true" selectLabel="Presione para seleccionar" open-direction="bottom" placeholder="Todos" @select="selecciona" />
                                        </div>
                                    </div>
                                </div>

                                <!--  -->

                                <div class="row">
                                    <div class="col">
                                        <h2>Codigos</h2>
                                        <hr>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group text-center">
                                            <multiselect v-model="discord_local.codigos" :options="codigos_local" :multiple="true" track-by="value" label="text" :close-on-select="false" :hide-selected="true" selectLabel="Presione para seleccionar" open-direction="bottom" placeholder="Todos" />
                                        </div>
                                    </div>
                                </div>

                                <!-- IMAGEN -->

                                <div class="row">
                                    <div class="col">
                                        <div style="display: flex;">
                                            <h2>Imagen</h2>
                                            <switchh class="ml-4 mt-2" :isEnabled="activos.imagen" @toggle="toggle('imagen')" />
                                        </div>
                                        <hr>
                                    </div>

                                </div>
                                <div class="row" v-if="activos.imagen">
                                    <div class="col-6">
                                        <div class="form-group text-center">
                                            <input type="text" class="form-control " v-model="discord_local.form.imagen">
                                        </div>
                                    </div>
                                </div>

                                <!-- IMAGEN -->

                                <div class="row">
                                    <div class="col">
                                        <div style="display:flex">
                                            <h2>Color</h2>
                                            <switchh class="ml-4 mt-2" :isEnabled="activos.color" @toggle="toggle('color')" />
                                        </div>

                                        <hr>
                                    </div>

                                </div>
                                <div class="row" v-if="activos.color">
                                    <div class="col-6">
                                        <div class="form-group text-center" st>
                                            <chrome v-model="discord_local.form.color" />
                                        </div>
                                    </div>
                                </div>

                                <!-- Mensaje -->

                                <div class="row">
                                    <div class="col">
                                        <h2>Mensaje</h2>
                                        <hr>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-md-6 msg-body-col">
                                        <div class="row">
                                            <div class="col-md-12" id="mensaje-section">
                                                <div class="hr-line-dashed"></div>
                                                <h4 class="text-center"><b>Mensaje</b></h4>
                                                <p>Ingrese el mensaje que desea enviar, puede utilizar etiquetas, emojis y dar formato al texto.</p>
                                            </div>
                                            <div class="col-md-12" id="mensaje-input-section">
                                                <div class="form-group">
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-addon"><i class="fal fa-comments"></i></span>
                                                        </div>
                                                        <textarea class="form-control no-resize" name="" id="" cols="30" rows="10" v-model="discord_local.form.mensaje" placeholder="Mensaje"></textarea>
                                                        <!-- {!! Form::textarea('body', '', ['id' => 'body','class'=>'form-control no-resize' .($errors->has('body') ? ' is-invalid' : ''), 'placeholder' => 'Mensaje']) !!} -->
                                                    </div>
                                                    <span id="cantidad_caracteres_body"></span> (Max 1024)

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6 msg-body-col">
                                        <div class="hr-line-dashed"></div>
                                        <label>Etiquetas (<a class="text-navy" data-toggle="popover" data-placement="auto" data-content="Utiliza estas etiquetas para decidir los datos personalizados a enviar."><i class="fa fa-question-circle"></i></a>)</label>
                                        <p class="text-justify">
                                            Si usted lo desea, puede incluir las etiquetas que se describen a continuación. Para incluir
                                            dichas etiquetas debe escribir (incluyendo los <code>&#123;&#123;</code> <code>&#125;&#125;</code> y en
                                            <strong>MAYÚSCULAS</strong>):<br>
                                        </p>

                                        <div class="row">
                                            <div class="col-md-6" v-for="(item, index) in etiquetas" :key="index">
                                                <code>{{ item.nombre }} </code>
                                                (<a v-if="item.descripcion" class="text-navy" v-popover-target="index.toString()"><i class="fa fa-question-circle"></i></a>)
                                                <popover :name="index.toString()">
                                                    {{item.descripcion}}
                                                </popover>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Footer -->

                                <div class="row">
                                    <div class="col">
                                        <div style="display:flex">
                                            <h2>Footer</h2>
                                            <switchh class="ml-4 mt-2" :isEnabled="activos.footer" @toggle="toggle('footer')" />
                                        </div>

                                        <hr>
                                    </div>

                                </div>
                                <div class="row" v-if="activos.footer">
                                    <div class="col-6">
                                        <div class="form-group text-center">
                                            <label for="">Texto</label>
                                            <input type="text" class="form-control" v-model="discord_local.form.footer.text">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group text-center">
                                            <label for="">Imagen</label>
                                            <input type="text" class="form-control" v-model="discord_local.form.footer.url_image">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col" style="    text-align: end;">
                                    <button class="btn btn-primary">Guardar</button>
                                </div>

                            </div>

                        </div>
                    </b-overlay>
                </div>
            </form>
        </div>
    </div>
</div>
</template>

<script>
import DataTable from '../../DataTableLuis.vue';
import Multiselect from "vue-multiselect";
import { Chrome } from 'vue-color'
import switchh from './switch';
export default {
    props: ["discord", "etiquetas_activos", "proveedores", "codigos"],
    components: { Multiselect, Chrome, switchh, DataTable },
    data() {
        return {
            dt: {
                id: 'lista-negra',
                columnas: [
                    { nombre: 'Nombre', nombre_variable: 'nombre' },
                    // { nombre: 'URL', nombre_variable: 'url' },
                    { nombre: 'Activo', nombre_variable: 'activo', slot: 1 },
                    { nombre: 'Opciones', nombre_variable: 'opciones', slot: 1 },
                ],
                datos: []
            },
            discord_local: {
                form: {
                    etiquetas: [],
                    codigos: [],
                    imagen: "",
                    color: "",
                    mensaje: "",
                    parametros_activos: [],
                    footer: {
                        text: "",
                        url_image: ""
                    }
                }
            },
            discords: [],
            discords_original: [],
            etiquetas: [],
            menciones: [],
            proveedores_local: [],
            proveedor: null,
            parametro: null,
            paramentros_proveedor: [],
            codigos_local: [],
            nuevo: false,
            editando: false,
            activos: {
                imagen: false,
                footer: false,
                color: false
            }
        }
    },
    mounted() {
        console.log(this.discord);
        this.dt.datos = this.discord;

    },
    methods: {
        activar(item){
            item.activo = !item.activo
            axios.post('discord/switch', {id:item.id, activo: item.activo}).then(reponse => {
            }).catch(error => {
            });
        },
        editar(item) {

            this.discord_local = item.data;
            this.discord_local['parametros_activos'] = [];
            this.discord_local['codigos'] = [];
            this.discord_local['form'] = {
                imagen: "",
                color: "",
                mensaje: "",
                footer: {
                    text: "",
                    url_image: ""
                }
            };

            // ------------- Etiquetas

            // this.form.etiquetas = JSON.parse(this.etiquetas_activos).map(e => {
            //     return {
            //         text: e.nombre,
            //         value: e.id
            //     }
            // })
            let configuracion = this.discord_local.configuracion;
            let menciones = configuracion.find(element => {
                return element.nombre == "etiquetas"
            })

            this.menciones = JSON.parse(menciones.valor).valor.map(e => {
                return {
                    text: e.nombre,
                    value: e.id,
                    activo: e.activo
                }
            });
            this.discord_local['etiquetas'] = this.menciones.filter(e => {
                return e.activo;
            })

            // ------------- Proveedores
            // console.log(this.proveedores);
            this.proveedores_local = this.proveedores.map(element => {
                return {
                    text: element.nombre,
                    value: element.id,
                    parametros: element.parametros
                }
            });

            let proveedores = configuracion.find(element => {
                return element.nombre == "proveedores"
            })

            // console.log(etiquetas);/
            JSON.parse(proveedores.valor).valor.forEach(element => {
                element.parametros.forEach(e => {
                    console.log(e);
                    let data = {
                        proveedor: element.proveedor,
                        metodo: e.metodo,
                        id: e.id
                    }
                    this.discord_local.parametros_activos.push(data)
                });

            });

            // ------------- Codigos
            // console.log(this.codigos);
            this.codigos_local = this.codigos.map(e => {
                return {
                    text: e.id + " | " + e.nombre,
                    value: e.id
                }
            });

            let codigos = configuracion.find(element => {
                return element.nombre == "codigos"
            })

            JSON.parse(codigos.valor).valor.forEach(element => {
                let c = this.codigos_local.find(e => {
                    return element == e.value
                })
                if (c)
                    this.discord_local.codigos.push(c);
            });


            /*  IMAGEN */

            let imagen = configuracion.find(element => {
                return element.nombre == "imagen"
            })

            this.activos.imagen = imagen.activo;

            this.discord_local.form.imagen = JSON.parse(imagen.valor).valor;

            /*  IMAGEN */
            

            let color = configuracion.find(element => {
                return element.nombre == "color"
            })
            
            this.activos.color = color.activo;
            
            this.discord_local.form.color = JSON.parse(color.valor).valor ?? {
                hex: '#194d33',
                hex8: '#194D33A8',
                hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
                hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
                rgba: { r: 25, g: 77, b: 51, a: 1 },
                a: 1
                };

            /* Mensaje */


            let mensaje = configuracion.find(element => {
                return element.nombre == "mensaje"
            })

            this.discord_local.form.mensaje = JSON.parse(mensaje.valor).valor;

            /* Etiquestas mensaje */


            let etiquetas = configuracion.find(element => {
                return element.nombre == "etiquetas_mensaje"
            })

            this.etiquetas = JSON.parse(etiquetas.valor).valor.map(e => {
                return {
                    nombre: e.nombre,
                    descripcion: e.descripcion
                }
            });


            let footer = configuracion.find(element => {
                return element.nombre == "footer"
            })

            this.activos.footer = footer.activo;


            let f = JSON.parse(footer.valor).valor


            this.discord_local.form.footer = f;

            this.editando = true;
            this.discords_original = JSON.parse(JSON.stringify(this.dt.datos));
            this.dt.datos = [];

        },
        eliminar(item, index) {
            this.discord_local.parametros_activos.splice(index, 1);
            this.$forceUpdate();
        },
        selecciona() {
            setTimeout(() => {
                let data = {
                    metodo: this.parametro.text,
                    proveedor: this.proveedor.text,
                    id: this.parametro.value
                }
                this.discord_local.parametros_activos.push(data);
                this.proveedor = null;
                this.parametro = null;
            }, 200);
        },
        toggle(tipo) {
            this.activos[tipo] = !this.activos[tipo]
        },
        save() {

         
            if (this.discord_local.nombre == "" || this.discord_local.url == "") {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Llene todo el formulario',
                    showConfirmButton: true,
                    timer: 1000,
                });
                return;
            }
            

            let codigos = this.discord_local.codigos.map(e => {
                return e.value
            });


            let data = JSON.parse(JSON.stringify(this.discord_local));
            data['codigos'] = codigos;

            data["activos"] = this.activos
            data['nuevo'] = this.nuevo;

            axios.post('discord/save', data).then(response => {
                this.$swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Guardado',
                    text: 'con exito',
                    showConfirmButton: true,
                    timer: 1500,
                })

                this.nuevo = false;
                this.editando = false;
                setTimeout(() => {
                    this.dt.datos = response.data.discord;
                }, 200);
                
              
            }).catch(error => {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Ha ocurrido un error',
                    showConfirmButton: true,
                    timer: 1000,
                });
            })
        },
        agregar() {

            if(this.nuevo || this.editando){
                // let data = JSON.parse(JSON.stringify(this.discords));
                this.discords = [];
                this.nuevo = false;
                this.editando = false;
                setTimeout(() => {
                this.dt.datos = this.discords_original;
                    
                }, 200);
                return;
            }

            this.menciones = this.menciones.map(e => {
                return {
                    text: e.text,
                    value: e.value,
                    activo: false
                }
            });

            let etiquetas = this.menciones.filter(e => {
                return e.activo;
            })

            let form = {
                imagen: "",
                color: "",
                mensaje: "",
                footer: {
                    text: "",
                    url_image: ""
                }
            };

            let discord_local = {
                form,
                etiquetas,
                url: "",
                nombre: "",
                parametros_activos: [],
                activo: true,
                codigos: [],
            };

            this.activos = {
                imagen: false,
                color: false,
                footer: false
            }
            this.discords.push(discord_local);
            this.discord_local = this.discords[this.discords.length - 1]
            this.nuevo = true

        }
    },
    watch: {
        proveedor() {
            if (this.proveedor) {
                console.log(this.proveedor.parametros);
                this.paramentros_proveedor = this.proveedor.parametros.map(e => {
                    return {
                        text: e.metodo_interno,
                        value: e.id,
                    }
                })
                console.log(this.paramentros_proveedor);
            }

        },
        discord_local() {
            this.$forceUpdate();
        }
    }

};
</script>
